import React, { useState, useEffect} from "react";
import { useLocation } from "react-router-dom";
import PaymentDetails from "../Customise-wheat/PaymentDetails";
import { GetUserAddresses, AddUserAddress, GetAllCities } from "../../Services/AddressService";

const Payment = () => {
    const [addresses, setAddresses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [savingAddress, setSavingAddress] = useState(false);
    const [addressOption, setAddressOption] = useState("existing");
    const [selectedAddressId, setSelectedAddressId] = useState(null);

    const [citySearchTerm, setCitySearchTerm] = useState("");
    const [selectedCity, setSelectedCity] = useState(null);
    const [cities, setCities] = useState([]);

    const location = useLocation();
    const { itemIds, totalAmount, couponCode} = location.state || {};
    const order = location.state?.order || null;

    const [cartData] = useState({
        amount: totalAmount,
        cartItemIds: itemIds,
        couponCode: couponCode
    });

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        address1: "",
        zipPostalCode: "",
        phoneNumber: "",
        addressType: "1",
        isDefault: false
    });

    const fetchAddresses = async (idToSelect = null) => {
        const userId = localStorage.getItem("userId");
        if (!userId) {
            setLoading(false);
            return;
        }
        try {
            const params = { userId: parseInt(userId) };
            // if (order) params.addressId = parseInt(order.shippingAddressId)
            const response = await GetUserAddresses(params);
            setAddresses(response.data);

            if (response.data.length > 0) {
                const defaultAddress = response.data.find(a => a.isDefault) || response.data[0];
                if (idToSelect) {
                    setSelectedAddressId(idToSelect);
                } else if (!selectedAddressId) {
                    setSelectedAddressId(defaultAddress.id);
                }
            } else {
                setAddressOption("new");
            }
        } catch (error) {
            console.error("Error fetching addresses:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        var orderAddressId = null;
        if (order) {
            orderAddressId = order.shippingAddressId;
        }
        fetchAddresses(orderAddressId);

        // Pre-fill form from localStorage
        const uName = localStorage.getItem("userName") || "";
        const uPhone = localStorage.getItem("phoneNumber") || "";
        const nameParts = uName.split(" ");
        setFormData(prev => ({
            ...prev,
            firstName: prev.firstName || nameParts[0] || "",
            lastName: prev.lastName || nameParts.slice(1).join(" ") || "",
            phoneNumber: prev.phoneNumber || uPhone
        }));

        const loc = localStorage.getItem("currentLocation");
        if (loc && !citySearchTerm) {
            const cityName = loc.split(",")[0]?.trim();
            if (cityName) setCitySearchTerm(cityName);
        }
    }, []);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === "checkbox" ? checked : value;
        setFormData({ ...formData, [name]: val });
    };

    const fetchCities = async (term = "") => {
        try {
            const response = await GetAllCities({ city: term });
            if (response.status) setCities(response.data.data);
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    };

    useEffect(() => {
        if (selectedCity != null) return;
        if (!citySearchTerm) {
            setCities([]);
            return;
        }
        const delayDebounce = setTimeout(() => {
            fetchCities(citySearchTerm);
        }, 400);
        return () => clearTimeout(delayDebounce);
    }, [citySearchTerm]);

    const handleCitySelect = (city) => {
        setSelectedCity(city);
        setCitySearchTerm(city.name);
        setCities([]);
    };

    const handleSaveAddress = async (e) => {
        e.preventDefault();
        const userId = localStorage.getItem("userId");
        const email = localStorage.getItem("email");
        if (!selectedCity) {
            alert("Please select a valid city from the dropdown.");
            return;
        }

        setSavingAddress(true);

        const payload = {
            userId: userId,
            firstName: formData.firstName,
            lastName: formData.lastName,
            address1: formData.address1,
            address2: "",
            zipPostalCode: formData.zipPostalCode,
            phoneNumber: formData.phoneNumber,
            email: email,
            cityId: selectedCity.id,
            stateId: selectedCity.stateId,
            countryId: selectedCity.countryId,
            addressType: parseInt(formData.addressType),
            isDefault: formData.isDefault
        };

        try {
            const response = await AddUserAddress(payload);
            if (response.status) {
                const newAddressId = response.data.id || response.data;
                setAddressOption("existing");
                await fetchAddresses(newAddressId);

                setFormData({ firstName: "", lastName: "", address1: "", zipPostalCode: "", phoneNumber: "", addressType: "1", isDefault: false });
                setCitySearchTerm("");
                setSelectedCity(null);
                // alert("Address saved and selected successfully.");
            } else {
                alert("Failed to add address: " + response.message);
            }
        } catch (error) {
            console.error("Error adding address:", error);
            alert("Something went wrong while saving address.");
        } finally {
            setSavingAddress(false);
        }
    };

    return (
        <div className="container">
            <div className="section-title pb_22">
                <h5>Complete registration payment</h5>
            </div>

            <div className="content-box">
                <div className="personal-details">

                    <h5 className="fs_20 fw_600 mb_20">Address Options</h5>
                    {/* Address Radio Buttons */}
                    <div className="d-flex gap-4 mb_10">
                        <div className="form-check custom-radio">
                            <input className="form-check-input" type="radio" id="existing" value="existing" checked={addressOption === "existing"} onChange={() => setAddressOption("existing")} />
                            <label className="form-check-label" htmlFor="existing">Select from existing</label>
                        </div>
                        {/* {order === null && ( */}
                            <div className="form-check custom-radio">
                            <input className="form-check-input" type="radio" id="new" value="new" checked={addressOption === "new"} onChange={() => setAddressOption("new")} />
                            <label className="form-check-label" htmlFor="new">Add new address</label>
                        </div>
                        {/* )} */}
                    </div>

                    {/* Existing Address List */}
                    {addressOption === "existing" && (
                        <div className="address-list mb_38">
                            {loading ? (<p>Loading...</p>) : addresses.length === 0 ? (
                                <p>No addresses found. Please add a new one.</p>
                            ) : (
                                <div className="row g-3">
                                    {addresses.map((address) => (
                                        <div key={address.id} className="col-lg-3 col-md-4 col-sm-6">
                                            <label className={`address-card p-3 rounded shadow-sm h-100 w-100`} style={{ cursor: 'pointer', border: selectedAddressId === address.id ? '2px solid #a37c4d' : '' }}>
                                                <div className="form-check custom-radio d-flex justify-content-between align-items-start mb_10">
                                                    <input type="radio" name="selectedAddress" checked={selectedAddressId === address.id} onChange={() => setSelectedAddressId(address.id)} className="form-check-input" />
                                                    <span className="tag fs_12 fw_500 lh-1 mt-1">{address.addressTypeName}</span>
                                                </div>
                                                <h6 className="fs_16 fw_500 text-color m-0 mb_6">{address.firstName} {address.lastName}</h6>
                                                <p className="fs_14 fw_400 text-color mb_2">{address.address1}</p>
                                                <p className="fs_14 fw_400 text-color mb_2">{address.cityName}, {address.stateName}</p>
                                                <p className="fs_14 fw_400 text-color mb_2">{address.zipPostalCode}</p>
                                                <p className="fs_14 fw_400 text-color">Mobile: <span className="fw_700">{address.phoneNumber}</span></p>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                    {/* New Address Form */}
                    {addressOption === "new" && (
                        <form className="mb_38" onSubmit={handleSaveAddress}>
                            <div className="mb_30">
                                <h5 className="fs_24 fw_700 lh-2 mb_5">Personal details</h5>
                                <div className="mb_20">
                                    <div className="d-flex gap-4 mb-2">
                                        <div className="form-check custom-radio"><input className="form-check-input" type="radio" name="addressType" id="Home" value="1" checked={formData.addressType === "1"} onChange={handleInputChange} /><label className="form-check-label" htmlFor="Home">Home</label></div>
                                        <div className="form-check custom-radio"><input className="form-check-input" type="radio" name="addressType" id="Office" value="2" checked={formData.addressType === "2"} onChange={handleInputChange} /><label className="form-check-label" htmlFor="Office">Office</label></div>
                                        <div className="form-check custom-radio"><input className="form-check-input" type="radio" name="addressType" id="Other" value="3" checked={formData.addressType === "3"} onChange={handleInputChange} /><label className="form-check-label" htmlFor="Other">Other</label></div>
                                    </div>
                                    <div className="form-check custom-checkbox">
                                        <input className="form-check-input" type="checkbox" name="isDefault" id="isDefault" checked={formData.isDefault} onChange={handleInputChange} />
                                        <label className="form-check-label" htmlFor="isDefault">Set as Default Address</label>
                                    </div>
                                </div>
                                {/* Form Inputs (First Name, Last Name, Phone, Address Line, Postal Code, City Search, State, Country) */}
                                <div className="row g-4">
                                    {/* ... (All form input fields for new address) ... */}
                                    <div className="col-lg-6"><div className="row g-3"><div className="col-md-6"><div className="form-input"><label className="form-label">First Name</label><input type="text" name="firstName" className="form-control" placeholder="John" value={formData.firstName} onChange={handleInputChange} required /></div></div><div className="col-md-6"><div className="form-input"><label className="form-label">Last Name</label><input type="text" name="lastName" className="form-control" placeholder="Doe" value={formData.lastName} onChange={handleInputChange} required /></div></div></div></div>
                                    <div className="col-lg-6"><div className="form-input"><label className="form-label">Phone Number</label><input type="text" name="phoneNumber" className="form-control" placeholder="9876543210" value={formData.phoneNumber} onChange={handleInputChange} required /></div></div>
                                    <div className="col-lg-12"><div className="form-input"><label className="form-label">Address line</label><input type="text" name="address1" className="form-control" placeholder="Apt. 493 Samual Alley" value={formData.address1} onChange={handleInputChange} required /></div></div>
                                    <div className="col-lg-6"><div className="form-input"><label className="form-label">Postal code</label><input type="text" name="zipPostalCode" className="form-control" placeholder="0606" value={formData.zipPostalCode} onChange={handleInputChange} required /></div></div>

                                    {/* City Search with Dropdown */}
                                    <div className="col-lg-6 position-relative">
                                        <div className="form-input">
                                            <label className="form-label">City</label>
                                            <input type="text" className="form-control" placeholder="Search city" value={citySearchTerm} onChange={(e) => { setCitySearchTerm(e.target.value); setSelectedCity(null); }} required />
                                        </div>
                                        {cities.length > 0 && (<ul className="dropdown-city-list" style={{ position: 'absolute', zIndex: 1000, background: '#fff', width: '100%', border: '1px solid #ddd', listStyle: 'none', padding: '10px', maxHeight: '200px', overflowY: 'auto' }}>
                                            {cities.map((city) => (<li key={city.id} className="dropdown-city-item p-2" style={{ cursor: 'pointer' }} onClick={() => handleCitySelect(city)}>{city.name}, {city.stateName}</li>))}
                                        </ul>)}
                                    </div>

                                    <div className="col-lg-6"><div className="form-input"><label className="form-label">State</label><input type="text" className="form-control" placeholder="State" value={selectedCity?.stateName || ""} readOnly /></div></div>
                                    <div className="col-lg-6"><div className="form-input"><label className="form-label">Country</label><input type="text" className="form-control" placeholder="Country" value={selectedCity?.countryName || ""} readOnly /></div></div>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-sm btn-primary" style={{ backgroundColor: "#a37c4d", border: "unset" }} disabled={savingAddress}>
                                {savingAddress ? "Saving..." : "Save & Select Address"}
                            </button>
                        </form>
                    )}

                    {/* Billing Address Question (Kept for completeness, no logic implemented here) */}
                    {/* <div>
                        <h5 className="fs_24 fw_600 lh-1 mb_20 mt_38">
                            Will your Billing and Shipping address same?
                        </h5>
                        <div className="d-flex align-items-center">
                            <div className="form-check custom-radio mr_38">
                                <input className="form-check-input" defaultChecked type="radio" name="billingSame" id="yes" />
                                <label className="form-check-label" htmlFor="yes">Yes</label>
                            </div>
                            <div className="form-check custom-radio">
                                <input className="form-check-input" type="radio" name="billingSame" id="no" />
                                <label className="form-check-label" htmlFor="no">No</label>
                            </div>
                        </div>
                    </div> */}

                    {/* Payment Methods Section */}
                    <div className="mt_38">
                        <h5 className="fs_24 fw_700 lh-2 mb_18">Payment methods</h5>
                        {/* 👈 Passing handler and selected address info */}
                        <PaymentDetails
                            selectedAddressId={selectedAddressId}
                            cartData={cartData}
                            order = {order}
                            isCustomisePayment={false}
                            setIsCustomisePayment={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Payment;